<template>
  <div class="wizard-body small-9 columns">
    <page-header
      :header-title="
        $t(title || 'INBOX_MGMT.ADD.API_CHANNEL.TITLE') + ' ' + subTitle
      "
      :header-content="$t('INBOX_MGMT.ADD.API_CHANNEL.DESC')"
    />
    <form
      v-if="account && account.features && account.features.add_wa_inbox"
      class="row"
      @submit.prevent="createChannel()"
    >
      <div class="medium-8 columns">
        <label :class="{ error: $v.selectedApiType.$error }">
          {{ $t('INBOX_MGMT.ADD.API_CHANNEL.API_TYPE.LABEL') }}
          <select
            id="apiType"
            v-model="selectedApiType"
            @blur="$v.selectedApiType.$touch"
          >
            <option value="" disabled selected>
              {{ $t('INBOX_MGMT.ADD.API_CHANNEL.API_TYPE.PLACEHOLDER') }}
            </option>
            <option
              v-for="(api, index) in apiTypes"
              :key="index"
              :value="Object.values(api)[0]"
            >
              {{ Object.keys(api)[0] }}
            </option>
          </select>
          <span v-if="$v.selectedApiType.$error" class="message">{{
            $t('INBOX_MGMT.ADD.API_CHANNEL.API_TYPE.ERROR')
          }}</span>
        </label>
      </div>
      <div class="medium-8 columns">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.webhookUrl.$error }">
          {{ $t('INBOX_MGMT.ADD.API_CHANNEL.WEBHOOK_URL.LABEL') }}
          <input
            v-model.trim="webhookUrl"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.API_CHANNEL.WEBHOOK_URL.PLACEHOLDER')
            "
            @blur="$v.webhookUrl.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.API_CHANNEL.WEBHOOK_URL.SUBTITLE') }}
        </p>
        <p>{{ account.id }}</p>
      </div>

      <div class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.API_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
    <div v-else>
      <div class="flex-1 overflow-auto p-4">
        <div class="flex flex-row gap-4">
          <div class="w-full flex justify-center">
            <h2 class="text-lg font-bold text-slate-600 dark:text-slate-300">
              {{ $t('INBOX_MGMT.WHATSAPP_NOTICE') }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader';

const shouldBeWebhookUrl = (value = '') =>
  value ? value.startsWith('http') : true;

export default {
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    subTitle: {
      type: String,
      required: false,
      default: '',
    },
    params: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      channelName: '',
      webhookUrl: '',
      selectedApiType: '',
      apiTypes: [{ v1: 'wa_v1' }, { v2: 'wa_v2' }, { v3: 'wa_v3' }],
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      accountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
    }),
    account() {
      return this.getAccount(this.accountId);
    },
  },
  validations: {
    channelName: { required },
    selectedApiType: { required },
    webhookUrl: { shouldBeWebhookUrl },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const apiChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName,
          channel: {
            type: 'api',
            webhook_url: this.webhookUrl,
            api_type: this.selectedApiType,
            ...(this.params || {}),
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: apiChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.API_CHANNEL.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>
